<script lang="ts">
    import { fade } from "svelte/transition";
    import { loaderProgressStore } from "../../Stores/LoaderStore";
    import defaultLoader from "../images/loading computer.gif";
</script>

<div
    class="absolute top-0 left-0 z-50 h-dvh w-dvw bg-[#F1F0EB] bg-no-repeat bg-contain bg-center"
    style="background-image: url(/static/images/map-bg.svg);"
    in:fade={{ duration: 100 }}
    out:fade={{ delay: 500, duration: 300 }}
>
    <div class="flex items-center justify-center w-full h-full relative">
        <div class="flex justify-center flex-col">
            <img
                draggable="false"
                src={defaultLoader}
                class="max-w-[450px] max-h-[450px] mb-0"
                alt="Logo loading screen"
            />
            <div class="w-full px-[44px]">
                <div class="border-mblue border-4 border-solid p-[8px]">
                    <div
                        class="h-[16px] transition-all duration-200 bg-mblue"
                        style="width: {$loaderProgressStore * 100}%;"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</div>
